import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import style from './style.module.less';

const getLabel = (batchName, fulfillmentPlanId) => {
  if (!fulfillmentPlanId) {
    return (
      <FormattedMessage
        defaultMessage='Batch: {number}'
        description='labelBatchStatus.batchNumberLabel'
        id='InZwj/'
        values={{ number: batchName }}
      />
    );
  }
  return (
    <FormattedMessage
      defaultMessage='Order # {number}'
      description='labelBatchStatus.orderNumberLabel'
      id='NJbgHe'
      values={{ number: batchName }}
    />
  );
};

export const LabelBatchHeader = ({ batchName, fulfillmentPlanId = '' }) => {
  if (!batchName) {
    return null;
  }
  return <div className={style.header}>{getLabel(batchName, fulfillmentPlanId)}</div>;
};

LabelBatchHeader.propTypes = {
  batchName: PropTypes.string,
  fulfillmentPlanId: PropTypes.string,
};
